import { useQuery } from '@tanstack/react-query';

import { SEGP_UI_BACKEND_URL, SEGP_WHITELIST_TOKEN } from '../environment';
import { FACETS } from '@/constants/facets';

export const FacetToSegpAppModeMapping = {
  [FACETS.Passenger]: '1',
  [FACETS.Driver]: '2',
  [FACETS.Merchant]: '3',
  [FACETS.MexStore]: '3',
  [FACETS.MexUser]: '3',
  [FACETS.MexMerchant]: '3',
};

export const useGetSegpNamespaceUCM = () =>
  useQuery({
    queryKey: ['getSegpNamespaceUCM'],
    queryFn: async () => {
      const res = await fetch(`${SEGP_UI_BACKEND_URL}/getservercapability`, {
        headers: {
          'x-xsrf-token': SEGP_WHITELIST_TOKEN,
        },
        method: 'GET',
      });
      return res.json();
    },
  });

export const FacetToSegpSearchEndpointMapping = {
  [FACETS.Passenger]: 'searchpaxgroup',
  [FACETS.Driver]: 'searchdrivergroup',
  [FACETS.Merchant]: 'searchmexgroup',
  [FACETS.MexStore]: 'searchmexgroup',
  [FACETS.MexUser]: 'searchmexgroup',
  [FACETS.MexMerchant]: 'searchmexgroup',
};

const DEFAULT_SEGMENT_RESULT_SIZE = 10;

export type Segment = {
  segmentName: string;
  namespace: string;
  properties: { [key: string]: string };
  createdBy?: string;
};

export const searchSegment = async ({
  facet,
  namespace,
  query,
  size = DEFAULT_SEGMENT_RESULT_SIZE,
}: {
  facet: string;
  namespace?: string;
  query?: string;
  size?: number;
}): Promise<{
  nextFrom: number;
  totalRows: number;
  segmentList: Segment[];
}> => {
  const payload = {
    condition: {
      name: query,
      namespace,
    },
    size,
  };
  const res = await fetch(
    `${SEGP_UI_BACKEND_URL}/${FacetToSegpSearchEndpointMapping[facet]}`,
    {
      headers: {
        'x-xsrf-token': SEGP_WHITELIST_TOKEN,
        accept: 'application/json',
        'content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
  return res.json();
};
